import React, { Component } from "react";
import { Breadcrumb, Table, Form, Input, Select, Button } from "antd";
import { Link } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";
import {
  FaAngleLeft,
  FaArrowLeft,
  FaArrowRight,
  FaSearch,
  FaTimes,
} from "react-icons/fa";
import "./SearchBonds.scss";
import searchIcon from "../../assets/search.png";

const { Search } = Input;
const suffix = (
  <FaSearch
    style={{
      fontSize: 20,
      color: "#939598",
    }}
  />
);

class SearchBonds extends Component {
  state = {
    showResult: false,
    showAddBond: false,
  };

  onSearch = (value) => {
    //console.log(value);
    this.setState({ showResult: true });
  };

  componentDidMount() {
    let data = [];

    for (let i = 0; i < 100; i++) {
      data.push({
        key: i,
        name: `محمد ابو سليمان`,
        orderId: 2213332123,
        totalOrder: 1200,
        phone: 1008270540,
        email: "test@test@gmail.com",
        address: `سداد مديونيه`,
        lastorder: "Wed Mar 24 2021 14:43:42",
      });
    }

    this.setState({ nameList: data });
  }

  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="prev-page-btn pagin-page-btn">
          <FaArrowRight /> الصفحة السابقة{" "}
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="next-page-btn pagin-page-btn">
          الصفحة التاليه <FaArrowLeft />{" "}
        </a>
      );
    }
    return originalElement;
  };

  render() {
    const { showResult, showAddBond } = this.state;

    return (
      <div className="search-bond-wapper">
        <div className="header-img-holder">
          <div className="container">
            <div className="client-header">
              <div className="client-header-first">
                <Breadcrumb separator=">">
                  <Breadcrumb.Item>
                    <Link to="/">
                      <HomeOutlined />
                      <p className="link-name">الرئيسية</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to="/orders">
                      <p className="link-name">الطلبات</p>
                    </Link>
                  </Breadcrumb.Item>
                  {/* <Breadcrumb.Item>
                    <Link to="/orders">
                      <p className="link-name">المتابعه</p>
                    </Link>
                  </Breadcrumb.Item> */}
                  <Breadcrumb.Item className="last-bread">
                    محمد ابو سليمان
                  </Breadcrumb.Item>
                </Breadcrumb>
                <h1>إنشاء سند جديد</h1>
              </div>
            </div>
          </div>
        </div>
        {showAddBond ? (
          <div className="add-bond-content">
            <div className="add-bond-header">
              <div className="container">
                <div className="header-info-row">
                  <div className="haeder-info-col">
                    <h6 className="info-title">اسم العميل</h6>
                    <p className="info-p">محمد ابو سليمان</p>
                  </div>
                  <div className="haeder-info-col">
                    <h6 className="info-title">جوال العميل</h6>
                    <p className="info-p">+96699874490</p>
                  </div>
                  <div className="haeder-info-col">
                    <h6 className="info-title">رقم هويه العميل</h6>
                    <p className="info-p">3343334533</p>
                  </div>
                  <div className="haeder-info-col">
                    <h6 className="info-title">رقم طلب التمويل</h6>
                    <p className="info-p">23221</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="add-bond-card">
              <div className="container">
                <div className="add-bond-card-content">
                  <h3>بيانات السند</h3>

                  <Form
                    className="form-add-content"
                    layout="vertical"
                    name="nest-messages"
                    onFinish={(values) => console.log(values)}
                  >
                    <div className="form-content">
                      <Form.Item
                        label="سبب السند"
                        name="orderFound"
                        className="input-holder"
                      >
                        <Select defaultValue={"سداد مديونيه"}>
                          <Select.Option value={"سداد مديونيه"}>
                            سداد مديونيه
                          </Select.Option>
                          <Select.Option value={"سداد مديونيه 5"}>
                            سداد مديونيه 5
                          </Select.Option>
                        </Select>
                      </Form.Item>
                      <Form.Item
                        label="قيمه السند"
                        name="buildingSak"
                        className="input-holder input-holder-mask"
                      >
                        <Input placeholder="" suffix="ر.س" />
                      </Form.Item>
                    </div>
                    <div className="form-add-btns">
                    <Button
                        type="primary"
                        size="large"
                        ghost
                        className="red-btn xlg"
                        icon={<FaTimes />}
                        onClick={() => this.props.history.push("/bonds")}
                      >
                        الغاء الطلب
                      </Button>
                      <Button
                        type="primary"
                        size="large"
                        className="xlg" 
                        onClick={() => this.props.history.push("/bonds")}
                      >
                        ارسال
                        <FaAngleLeft />
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="search-bond-content">
            <div className="container">
              <div className="search-bond-content--header">
                <h3>اختر العميل</h3>
                <div className="order-header-search">
                  <Search
                    placeholder="البحث برقم الطلب٬ اسم العميل٫ جوال العميل٫ رقم هويه العميل"
                    allowClear
                    enterButton=" بحث"
                    size="large"
                    prefix={suffix}
                    onSearch={this.onSearch}
                  />
                </div>
              </div>
              <div className="search-result-holder">
                {showResult ? (
                  <Table
                    // loading={tableLoading}
                    pagination={{ simple: true, itemRender: this.itemRender }}
                    editable
                    onRow={(record, rowIndex) => {
                      return {
                        onClick: (event) => {
                          this.setState({
                            activeuser: record,
                            showAddBond: true,
                          });
                        },
                      };
                    }}
                    // rowKey = "id"
                    className="table-roles-wrapper app-table-wrapper table-hover-wrapper order-table"
                    columns={[
                      {
                        title: `رقم الطلب`,
                        dataIndex: "orderId",
                      },
                      {
                        title: `الاسم`,
                        dataIndex: "name",
                      },
                      {
                        title: `رقم الجوال`,
                        dataIndex: "phone",
                      },
                      {
                        title: `رقم هويه العميل`,
                        dataIndex: "orderId",
                      },
                    ]}
                    dataSource={this.state.nameList}
                  />
                ) : (
                  <div className="result-content">
                    <img src={searchIcon} alt="" />
                    <h3 className="search-title">لا توجد نتائج بحث</h3>
                    <p className="search-label">
                      قم بالبحث برقم الطلب٬ اسم العميل٫ جوال العميل٫ رقم هويه
                      العميل
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SearchBonds;
 
// const SearchBondsWithRouter = withRouter(SearchBonds);
// const mapStateToProps = (state) => ({
//   currentUser : state.user.currentUser,
// }) 
// export default connect(mapStateToProps)(SearchBondsWithRouter);  